import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Cone: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98' }],
    ['ellipse', { cx: '12', cy: '19', rx: '9', ry: '3' }],
  ],
];

export default Cone;
